module.exports = "/static/img/drop-color.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen3/water/img/drop-color.png
// module id = 465
// module chunks = 0